import { render } from "./TooltipLabel.vue?vue&type=template&id=14dc27c5&scoped=true"
import script from "./TooltipLabel.vue?vue&type=script&lang=js"
export * from "./TooltipLabel.vue?vue&type=script&lang=js"

import "./TooltipLabel.vue?vue&type=style&index=0&id=14dc27c5&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14dc27c5"]])

export default __exports__